import { Button } from "../../../../components/ui";
import HomeSearchBlock from "../HomeSearchBlock";
import { handleEvaluationButtonClick } from "../../../../utils/redirectToNewReview";

const HeroHeader = () => {
  return (
    <div className="flex flex-col lg:flex-row gap-4 mx-auto max-w-screen-xl">
      <div className="col-span-1 lg:col-span-3">
        <h1 className="mb-4">
          Des avis automobiles auxquels vous pouvez
          <strong className="primary-color"> vraiment faire confiance.</strong>
        </h1>
        <p className="text-muted-foreground">
          Des expériences authentiques de vrais conducteurs.
          <br />
          Des avis indépendants et transparents pour
          <br />
          vous aider à faire le bon choix.
        </p>
        <div className="flex flex-col gap-4 lg:flex-row mt-5">
          <Button
            size="lg"
            onClick={() =>
              handleEvaluationButtonClick({ page_type: "Hero header" })
            }
          >
            Évaluer mon véhicule
          </Button>
        </div>
      </div>
      <div className="flex-shrink-0 lg:max-w-[563px] lg:min-w-[45%]">
        <HomeSearchBlock />
      </div>
    </div>
  );
};

export default HeroHeader;
